import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid } from 'semantic-ui-react';
import * as moment from 'moment';
import { isMoment } from 'moment';
import { toastr } from 'react-redux-toastr';
import { date_format } from '../../global_constants';
import * as report_constants from '../report_constants';
import * as session_storage from '../../shared/session_storage_utility';
import DateRangePickerComponent from '../../shared/component/date_range_component';
import SelectionComponent from '../../shared/component/selection_component';
import CheckboxComponent from '../../shared/component/checkbox_component';
import { custom_date_format } from '../../shared/utility';
import PatientLedgerEditColumnsButtonComponent from './patient_ledger_edit_columns_button_component';

class PatientLedgerReportSearchCriteriaComponent extends React.Component<any, any> {
    is_submitted = false;
    patient_name: string;
    account_no: string;
    current_date: string;
    company_name: any;
    title: string;
    report_metadata: any[];
    report_data: any[];
    total_column_width: number = 0;
    grid_header_height: number = 0;
    report_container: any;
    run_report_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');
    is_mounted = false;
    default_start_date: moment.Moment;
    default_end_date: moment.Moment;

    constructor(props) {
        super(props);
        // Initialize default dates before using them in state
        this.default_start_date = moment("01/01/1975");
        this.default_end_date = moment(custom_date_format(new Date().toString(), date_format["mm/dd/yyyy"]));
        
        this.state = {
            search_criteria: {
                start_date: this.default_start_date,
                end_date: this.default_end_date,
                is_active: false,
                patient_id: session_storage.get('active_patient'),
                report_type: '1'
            },
            report_title: 'Ledger',
            is_error_date_range: false,
            is_error_group_by: false,
            group_by_selection_data: {
                default_value: '1',
                options: [
                    {
                        value: '1',
                        text: 'Visit',
                        selected: true
                    },
                    {
                        value: '2',
                        text: 'Charge',
                        selected: false
                    }
                ]
            },
            is_grid_visible: false,
            loading: false,
        }
    }

    componentWillUnmount = () => {
        this.is_mounted = false;
    }

    componentDidMount() {
        this.is_mounted = true;
    }

    change_handler = (value, event) => {
        this.setState(prevState => ({
            search_criteria: { ...prevState.search_criteria, report_type: value }
        }));
    }

    clear_handler = () => {
        //use report_search_criteria_component >> clear_handler() as a model for this methods code.
        if (this.is_mounted) {
            this.setState({
                search_criteria: { 
                    ...this.state.search_criteria, 
                    start_date: this.default_start_date, 
                    end_date: this.default_end_date, 
                    report_type: '1',
                    is_active: false
                },
                group_by_selection_data: { 
                    ...this.state.group_by_selection_data, 
                    default_value: '1',
                    options: this.state.group_by_selection_data.options.map(option => ({
                        ...option,
                        selected: option.value === '1'
                    }))
                },
                is_error_date_range: false,
                is_error_group_by: false
            })
        }
        this.is_submitted = false;
        this.props.on_clear();
    }

    handleDateChange = (startDate, endDate) => {
        this.setState(prevState => ({
            search_criteria: { ...prevState.search_criteria, start_date: startDate, end_date: endDate },
            is_error_date_range: (isMoment(startDate) ? false : true) || (isMoment(endDate) ? false : true)
        }));
    }

    run_report_handler = () => {
        this.is_submitted = true;
        if (this.state.search_criteria.start_date && this.state.search_criteria.end_date) {
            if (this.state.search_criteria.start_date._d <= this.state.search_criteria.end_date._d) {
                //this.on_run_report_handler(this.state.search_criteria);
                this.props.on_run_report(this.state.search_criteria);
            }
            else {
                toastr.error('', report_constants.messages.date_validation);
            }
        }
        else {
            if (!this.state.search_criteria.start_date || !this.state.search_criteria.end_end) {
                this.setState({ is_error_date_range: true })
            }
            toastr.error('', report_constants.messages.mandatory_fields);
        }
    }

    render() {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Column tablet={8} computer={4}>
                        <Form.Field>
                            <label>Date Range {<span className={this.state.is_error_date_range ? 'req-alert' : 'req-alert_normal'}> (required)</span>}
                            </label>
                            <DateRangePickerComponent
                                updateDatesChange={this.handleDateChange}
                                startDate={this.state.search_criteria.start_date}
                                endDate={this.state.search_criteria.end_date}
                                error={this.state.is_error_date_range}
                                startYear={1975}
                            />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column tablet={8} computer={4}>
                        <Form.Field>
                            <label>Group By {<span className={this.state.is_error_group_by ? 'req-alert' : 'req-alert_normal'}> (required)</span>}
                            </label>
                            <SelectionComponent
                                id='patient-ledger-group-by-selection'
                                name='patient_ledger_group_by_selection'
                                options={this.state.group_by_selection_data.options}
                                onChange={this.change_handler}
                                defaultValue={this.state.group_by_selection_data.default_value}
                                style={'dropdown-options-wrap'}
                            />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column tablet={8} computer={3} className="ledger-show-inactive-checkbox">
                        <CheckboxComponent
                            label='Show Inactive'
                            checked={this.state.search_criteria.is_active}
                            id="patient-ledger-show-inactive"
                            onChange={(evt, checked) => {
                                this.setState((prev) => ({
                                    search_criteria: {
                                        ...prev.search_criteria, is_active: checked
                                    }
                                }))
                            }}
                            disabled={false}
                        />
                    </Grid.Column>
                    {this.props.show_edit_columns_button && (
                        <Grid.Column tablet={8} computer={5} textAlign="right">
                            <PatientLedgerEditColumnsButtonComponent
                                onEditColumnsButtonHandler={this.props.onEditColumnsButtonHandler}
                            />
                        </Grid.Column>
                    )}
                    <Grid.Column tablet={16} computer={16} textAlign='right'>
                        <Button type='reset' id='patient-ledger-clear-button' onClick={this.clear_handler} basic >Clear</Button>
                        <Button
                            onKeyDown={this.props.handle_navigation_after_last_element}
                            type='submit'
                            onClick={this.run_report_handler}
                            disabled={this.props.is_search_button_disabled}
                            id='patient-ledger-search-button' primary>Search</Button>
                    </Grid.Column>
                </Grid>
            </React.Fragment>
        );
    }
}

//Get user and login details from store.
const mapStateToProps = state => {
    return {
        user_login_details: state.user_login_details,
        selected_patient: state.patient_details.patient_header,
        is_expand: state.shared_details.is_expand
    };
};

export default connect(mapStateToProps)(PatientLedgerReportSearchCriteriaComponent);